import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.28153 23.0312L9.25 13.0312H5.25V9.03125H9.25V6.53125C9.25 2.81985 11.5483 1.03125 14.8591 1.03125C16.4451 1.03125 17.8081 1.14932 18.2053 1.2021V5.08073L15.9091 5.08177C14.1084 5.08177 13.7598 5.93739 13.7598 7.19296V9.03125H19L17 13.0312H13.7598V23.0312H9.28153Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }